import type { AddinCommandSurfaceItem, AddinLocation } from 'owa-addins-types';

export default function convertToIContextualMenuItem(
    hostItemIndex: string,
    item: AddinCommandSurfaceItem,
    targetWindow: Window
) {
    const addinLocation: AddinLocation = {
        hostItemIndex: hostItemIndex,
        targetWindow: targetWindow,
    };
    // Set property that will be used in compose command bar collapse logic
    item.isAddin = true;
    if (item.getClickHandler) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (18,9): Type '(event?: MouseEvent<HTMLElement, MouseEvent> | undefined) => void' is not assignable to type '(ev?: MouseEvent<HTMLElement, MouseEvent> | KeyboardEvent<HTMLElement> | undefined, item?: IContextualMenuItem | undefined) => boolean | void'.
        // @ts-expect-error
        item.onClick = item.getClickHandler(addinLocation);
    } else if (item.sectionProps) {
        const items = item.sectionProps.items;
        items.forEach(menuItem => {
            convertToIContextualMenuItem(hostItemIndex, menuItem, targetWindow);
        });
    } else if (item.subMenuProps) {
        const items = item.subMenuProps.items;
        items.forEach(menuItem => {
            convertToIContextualMenuItem(hostItemIndex, menuItem, targetWindow);
        });
    }
}
